import React, { PropsWithChildren } from 'react';
import { useFlagValue } from './hooks';
import { TFlags } from './constants-flags';

type IProps = {
  flag: TFlags;
};
// Re-Exporting Flags constants since its always going to be used in pair with hook and component
export { Flags } from './constants-flags';
export const Flight = (props: PropsWithChildren<IProps>) => {
  const { children, flag } = props;
  const flagValue = useFlagValue(flag);
  return !flagValue ? null : <>{children}</>;
};
